<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0"  aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>

      <tr class="light-grey-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'renewalProbability'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.renewalProbability}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.renewalProbabilityComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.renewalProbabilityComment= $event;"
          id="renewalProbabilityComment" [(ngModel)]="widgetData.renewalProbabilityComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="white-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'specificTenantAssumptions'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.specificTenantAssumptions}}</label></widget-value></td>
        <td colspan="9" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.specificTenantAssumptions= $event;"
          id="specificTenantAssumptions" [(ngModel)]="widgetData.specificTenantAssumptions" (ngModelChange)="setDirtyFlag(true)" /></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.specificTenantAssumptionsComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.specificTenantAssumptionsComment= $event;"
          id="specificTenantAssumptionsComment" [(ngModel)]="widgetData.specificTenantAssumptionsComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="light-grey-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'voidInitial'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.voidInitial}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.voidInitialComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.voidInitialComment= $event;"
          id="voidInitialComment" [(ngModel)]="widgetData.voidInitialComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="white-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'voidUponExpiry'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.voidUponExpiry}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.voidUponExpiryComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.voidUponExpiryComment= $event;"
          id="voidUponExpiryComment" [(ngModel)]="widgetData.voidUponExpiryComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="light-grey-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'renewalRentFree'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.renewalRentFree}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.renewalRentFreeComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.renewalRentFreeComment= $event;"
          id="renewalRentFreeComment" [(ngModel)]="widgetData.renewalRentFreeComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="white-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'renewalTenantIncentives'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.renewalTenantIncentives}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.renewalTenantIncentivesComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.renewalTenantIncentivesComment= $event;"
          id="renewalTenantIncentivesComment" [(ngModel)]="widgetData.renewalTenantIncentivesComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="light-grey-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'renewalLettingFees'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.renewalLettingFees}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.renewalLettingFeesComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.renewalLettingFeesComment= $event;"
          id="renewalLettingFeesComment" [(ngModel)]="widgetData.renewalLettingFeesComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="white-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'newLettingFree'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.newLettingFree}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.newLettingRentFreeComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.newLettingRentFreeComment= $event;"
          id="newLettingRentFreeComment" [(ngModel)]="widgetData.newLettingRentFreeComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="light-grey-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'newTenantIncentives'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.newTenantIncentives}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.newLettingTenantIncentivesComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.newLettingTenantIncentivesComment= $event;"
          id="newLettingTenantIncentivesComment" [(ngModel)]="widgetData.newLettingTenantIncentivesComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="white-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'newLettingCosts'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9"><widget-value [align]="'left'" [bold]="true" [color]="'black'">{{widgetData.newLettingCosts}}</widget-value></td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.newLettingLettingCostsComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.newLettingLettingCostsComment= $event;"
          id="newLettingLettingCostsComment" [(ngModel)]="widgetData.newLettingLettingCostsComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

      <tr class="light-grey-line">
        <td colspan="9"><widget-label [widget]="this" [fieldName]="'otherCommentsComment'" [align]="'left'" [bold]="true" [color]="'dark-gray'"></widget-label></td>
        <td colspan="9">&nbsp;</td>
        <td colspan="15" *ngIf="!editMode"><widget-value [align]="'left'" [bold]="true" [color]="'black'"><label hashtagsetvalue [widget]="this" [page]="page">{{widgetData.otherCommentsComment}}</label></widget-value></td>
        <td colspan="15" *ngIf="editMode"><input type="text" class="widget-input-text gridster-item-content"    
          hashtag [widget]="this" [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
          [elType]="'text'" [page]="page"  
          [editMode]="editMode" 
          (setNewValue)="widgetData.otherCommentsComment= $event;"
          id="otherCommentsComment" [(ngModel)]="widgetData.otherCommentsComment" (ngModelChange)="setDirtyFlag(true)" /></td>
      </tr>

    </tbody>
  </table>
</div>
